// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_array = require("rescript/lib/js/caml_array.js");

function TextFileReader2(Props) {
  var onChange = Props.onChange;
  return React.createElement("input", {
              type: "file",
              onChange: (function (evt) {
                  var fr = new FileReader();
                  var files = evt.nativeEvent.target.files;
                  if (files.length === 0) {
                    return Curry._1(onChange, undefined);
                  }
                  var file = Caml_array.get(files, 0);
                  var fileName = file.name;
                  fr.onload = (function (param) {
                      var fileText = fr.result;
                      Curry._1(onChange, [
                            fileName,
                            fileText
                          ]);
                    });
                  fr.readAsBinaryString(file);
                })
            });
}

var make = TextFileReader2;

exports.make = make;
/* react Not a pure module */
